import { useEffect, useState } from 'react'
import { Logo } from './Logo'
import { Search } from 'lucide-react'

const nav = [
  { label: 'Categorias', href: '#categorias' },
  { label: 'Compras', href: '#compras' },
  { label: 'Milhas', href: '#milhas' },
]

export function Header() {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-bone/85 backdrop-blur-md border-b border-taupe/15 py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="container-editorial flex items-center justify-between gap-6">
        <a
          href="#top"
          aria-label="mile to mile — página inicial"
          className="flex items-center gap-3 group"
        >
          <Logo variant="static" className="text-xl md:text-2xl" />
          <span className="hidden md:inline-flex text-[10px] tracking-[0.3em] uppercase text-taupe border-l border-taupe/40 pl-3 ml-1 py-0.5 leading-none">
            o melhor de milhas, curado
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-sm text-ink/70 hover:text-ink px-3 py-2 rounded-full hover:bg-sand/50 transition-all"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            aria-label="Buscar"
            className="hidden md:inline-flex items-center justify-center w-10 h-10 rounded-full hover:bg-sand/50 transition-colors text-ink/70 hover:text-ink"
          >
            <Search className="w-4 h-4" strokeWidth={1.5} />
          </button>
          <a href="#entrar" className="btn-primary !py-2.5">
            Receber alertas
          </a>
        </div>
      </div>
    </header>
  )
}
